import script from "./LotCurrencyList.vue?vue&type=script&setup=true&lang=ts"
export * from "./LotCurrencyList.vue?vue&type=script&setup=true&lang=ts"

import "./LotCurrencyList.vue?vue&type=style&index=0&id=a816cab0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a816cab0"]])

export default __exports__